import { LmIconFilledBusinessBarChartSorted, LmIconOutlineBusinessBarChartSorted } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconStudyDiagnosticsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? (
    <LmIconOutlineBusinessBarChartSorted {...rest} />
  ) : (
    <LmIconFilledBusinessBarChartSorted {...rest} />
  );

export default IconStudyDiagnosticsCommon;
